export const DESCRIPTION_KEY = 'DESCRIPTION';
export const ADDRESS_KEY = 'ADDRESS';
export const AREA_MAP_KEY = 'AREA_MAP';
export const TIMELINE_KEY = 'TIMELINE';
export const FLOODING_KEY = 'FLOODING';
export const GRADING_KEY = 'GRADING';
export const PAYMENT_KEY = 'PAYMENT';
export const CONTACT_KEY = 'CONTACT';
export const PHOTO_KEY = 'PHOTO';
export const VIDEO_KEY = 'VIDEO';